/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Require_Payment_Before_AccessiInputs */

const en_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Require payment before accessing files`)
};

const es_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerir pago antes de acceder a los archivos`)
};

const fr_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exiger un paiement avant d'accéder aux fichiers`)
};

const de_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung vor Zugriff auf Dateien verlangen`)
};

const ja_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルにアクセスする前に支払いを要求する`)
};

const zh_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问文件前需先付款`)
};

const ar_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طلب الدفع قبل الوصول إلى الملفات`)
};

const id_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wajibkan pembayaran sebelum mengakses file`)
};

const it_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi il pagamento prima di accedere ai file`)
};

const ru_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требовать оплату перед доступом к файлам`)
};

const pt_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exigir pagamento antes de acessar os arquivos`)
};

const ko_require_payment_before_accessi = /** @type {(inputs: Require_Payment_Before_AccessiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 접근 전 결제 요구`)
};

/**
* | output |
* | --- |
* | "Require payment before accessing files" |
*
* @param {Require_Payment_Before_AccessiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const require_payment_before_accessi = /** @type {((inputs?: Require_Payment_Before_AccessiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Require_Payment_Before_AccessiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_require_payment_before_accessi(inputs)
	if (locale === "es") return es_require_payment_before_accessi(inputs)
	if (locale === "fr") return fr_require_payment_before_accessi(inputs)
	if (locale === "de") return de_require_payment_before_accessi(inputs)
	if (locale === "ja") return ja_require_payment_before_accessi(inputs)
	if (locale === "zh") return zh_require_payment_before_accessi(inputs)
	if (locale === "ar") return ar_require_payment_before_accessi(inputs)
	if (locale === "id") return id_require_payment_before_accessi(inputs)
	if (locale === "it") return it_require_payment_before_accessi(inputs)
	if (locale === "ru") return ru_require_payment_before_accessi(inputs)
	if (locale === "pt") return pt_require_payment_before_accessi(inputs)
	return ko_require_payment_before_accessi(inputs)
});